import { Box, Button, Container, IconButton, lighten, Paper, Typography, useTheme } from '@mui/material';
import { JsonView } from 'react-json-view-lite';
import Modal from '../../common/Modal';
import { ReactComponent as CopyIcon } from '../../assets/connectivitydashboard/copy-icon.svg';
import { palette } from '../../theme/palette';
import CopyToClipboard from 'react-copy-to-clipboard';
import Snackbar from '../../common/snackBar';
import { useOutletContext } from 'react-router-dom';
import get from 'lodash/get';

const Styles = {
  pageWrapper: { display: 'flex', flexDirection: 'column', rowGap: 4 },
  filterContainer: {
    wrapper: { display: 'flex', alignItems: 'center', height: 32 },
    filterByTextWrapper: { display: 'flex', gap: 2, width: 140, mr: 2 },
    stack: {
      '&.MuiStack-root>:not(style)~:not(style)': { marginLeft: 2 },
      overflow: 'auto',
    },
    chip: {
      borderRadius: '8px',
      '& .MuiChip-label': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
  },
  tableContainer: {
    container: { boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px', height: '100%' },
    paper: {
      margin: 'auto',
      boxShadow: '0px 0px 14px 0px #0000000D',
      borderRadius: '18px',
      border: `1px solid #D9DFED`,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    viewAllBtnWrapper: { display: 'flex', justifyContent: 'end', p: 2 },
  },
  chartWrapper: {
    container: { boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px' },
    paper: {
      margin: 'auto',
      boxShadow: '0px 0px 14px 0px #0000000D',
      borderRadius: '18px',
      border: `1px solid #D9DFED`,
      height: 560,
    },
    headerWrapper: {
      p: 3,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      boxSizing: 'border-box',
      height: '87px',
    },
    selectWrapper: { display: 'flex', alignItems: 'center', columnGap: 3 },
    select: {
      fontSize: '16px',
    },
    selectMenuProps: {
      PaperProps: {
        sx: {
          '&.MuiPaper-root': {
            border: '1px solid #D9DFED',
            boxShadow:
              '0px 2px 2px -3px rgba(0,0,0,0.1),0px 4px 10px 1px rgba(0,0,0,0.1),0px 1px 14px 1px rgba(0,0,0,0.1)',
          },
          '& .MuiList-root': {
            padding: '0px',
          },
          '& .MuiMenuItem-root': {
            color: '#64759F',
            fontWeight: 400,
            fontSize: '16px',
            paddingLeft: '14px',
            paddingRight: '14px',
          },
        },
      },
    },
    bodyWrapper: {
      // pt: 7,
      // pb: 6,
      // minHeight: 400,
      // maxHeight: 400,
      // width: '100%',
      height: 472,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
    },
    loadingWrapper: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  // cardsContainer: {
  //   wrapper: {
  //     // mt: 4,
  //     display: 'flex',
  //     flexWrap: 'wrap',
  //     // justifyContent: 'space-between',
  //     gap: 3,
  //   },
  //   card: { width: '188px' },
  //   cardContent: {
  //     p: 0,

  //     '&:last-child': {
  //       pb: 0,
  //     },
  //   },
  //   assetsWrapper: {
  //     display: 'flex',
  //     justifyContent: 'space-between',
  //     mt: 2,
  //   },
  //   asset: {
  //     display: 'flex',
  //     alignItems: 'center',
  //     gap: 1,
  //   },
  // },
  dataTable: {
    '& .MuiDataGrid-virtualScroller': {
      pb: 1,
      overflow: 'auto',
      overflowY: 'hidden',
      minHeight: '100%',
    },
    '&.MuiDataGrid-root': {
      height: '100%',
      minHeight: '100%',
    },
  },
  tableCellText: {
    fontSize: '16px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  severityChip: {
    '& .MuiChip-label': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  chartModal: {
    paperProps: {
      sx: {
        padding: '32px',
        borderRadius: '18px',
        width: '70%',
        maxWidth: '70%',
        height: '90%',
      },
    },
    dailogContent: {
      '&.MuiDialogContent-root': {
        padding: '0px',
        backgroundColor: `${palette.primary.contrastText}`,
        borderRadius: '18px',
      },
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 2,
    },
    dailogTitle: {
      fontSize: '20px',
      color: `${palette.disabled.dark}`,
      fontFamily: 'Open Sans',
      fontWeight: '400',
      p: 0,
    },
    headerWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 2,
    },
    bodyWrapper: {
      width: '100%',
      height: 'calc(100% - 150px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      overflow: 'hidden',
    },
    loadingWrapper: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    closeBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      pt: 2,
      pb: 2,
    },
  },
  notificationsTableWrapper: {
    paddingInline: 3,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    boxSizing: 'border-box',
    height: '87px',
  },
  notificationsTable: {
    '& .MuiDataGrid-virtualScroller': {
      pb: 1,
      overflow: 'auto',
    },
    '&.MuiDataGrid-root': {
      height: 400,
      minHeight: 400,
    },
  },
  notificationsTableSearchWrapper: { display: 'flex', alignItems: 'center', columnGap: 3 },
  notificationsTableSearch: { fontSize: '16px', width: '300px' },
  // Gateways & Assets Table
  gatewaysAssetsTableWrapper: {
    paddingInline: 3,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    boxSizing: 'border-box',
    height: '87px',
  },
  gatewaysAssetsTab: { '&.MuiTab-root': { fontSize: '18px' } },
  gatewaysAssetsTableSearchWrapper: { display: 'flex', alignItems: 'center', columnGap: 3 },
  gatewaysAssetsTableSearch: { fontSize: '16px', width: '300px' },
  messageModal: {
    container: { boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px' },
    paper: {
      margin: 'auto',
      boxShadow: '0px 0px 14px 0px #0000000D',
      borderRadius: '18px',
      border: `1px solid #D9DFED`,

      overflow: 'hidden',
    },
    header: {
      p: 3,
      display: 'flex',
      justifyContent: 'flex-end',
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      boxSizing: 'border-box',
      // height: '87px',
    },
    searchFieldWrapper: { display: 'flex', alignItems: 'center', columnGap: 3 },
    dataTableWrapper: {
      height: '100%',
      overflow: 'hidden',
      padding: '24px',
      radius: '18px',
    },
    dataTable: {
      '& .MuiDataGrid-virtualScroller': {
        overflow: 'auto',
      },
      '&.MuiDataGrid-root': {
        height: 'calc(80vh - 196px)',
        minHeight: 'calc(80vh - 196px)',
      },
    },
    closeBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBlock: 4,
      marginTop: '24px',
    },
    tableCellText: {
      fontSize: '16px',
      fontWeight: 400,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  },
  connectedIcon: { color: '#0EAB4E', cursor: 'pointer', paddingLeft: '12px' },
  disConnectedIcon: { color: '#D81010', cursor: 'pointer', paddingLeft: '8px' },
};

const LatestMessagePopup = ({ popupMsgData, handleMsgPopupClose, copyData }: any) => {
  const theme = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});

  return (
    <Modal
      title={`${popupMsgData.title.toUpperCase()}`}
      open={popupMsgData.status}
      customStyles={{ width: 'auto', minWidth: '40%' }}
      handleClose={handleMsgPopupClose}
    >
      <Container maxWidth={false} disableGutters sx={Styles.messageModal.container}>
        <Paper
          sx={{
            ...Styles.messageModal.paper,
            border: `1px solid  ${theme.palette.customBorderColor.main}`,
            backgroundColor: themeMode.isLightBG
              ? lighten(theme.palette.background.default, 0.9)
              : lighten(theme.palette.background.default, 0.05),
          }}
        >
          <Box sx={{ ...Styles.messageModal.dataTableWrapper, display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {popupMsgData.type != 'MQTT' && (
              <Typography
                sx={{
                  textTransform: 'capitalize',
                  fontSize: '16px',
                  color: '#434D67',
                  padding: 0,
                  margin: 0,
                  lineHeight: 1,
                }}
              >
                {popupMsgData.type} Message
              </Typography>
            )}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                minHeight: 270,
                padding: '24px 16px 24px 16px',
                border: `1px solid  ${theme.palette.customBorderColor.main}`,
                // backgroundColor: '#D9DFED40',
                // border: '1px solid #D9DFED',
                borderRadius: '8px',
              }}
            >
              <Box>{popupMsgData.status && <JsonView data={popupMsgData.item} />}</Box>
              {/* <Box>
                <IconButton
                  onClick={() => {
                    copyData(popupMsgData.item);
                  }}
                >
                  <CopyIcon />
                </IconButton>
              </Box> */}
              <CopyToClipboard
                text={JSON.stringify(popupMsgData.item || {})}
                onCopy={() => {
                  Snackbar.info('Copied!');
                }}
              >
                <IconButton
                  sx={{
                    padding: 0,
                    '&.MuiIconButton-root:hover': { backgroundColor: 'transparent !important', textDecoration: 'none' },
                  }}
                >
                  <CopyIcon />
                </IconButton>
              </CopyToClipboard>
            </Box>
            <Box sx={{ ...Styles.messageModal.closeBtnWrapper, marginTop: 0, padding: 0 }}>
              <Button variant='outlined' onClick={handleMsgPopupClose}>
                Close
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Modal>
  );
};
export default LatestMessagePopup;
